import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { FaStar, FaBolt, FaShield, FaAward } from "react-icons/fa6";
import "./ApplyWhoCanApply.css";

const ease = [0.22, 1, 0.36, 1];
const fadeUp = (d = 0) => ({ hidden: { opacity: 0, y: 20 }, show: { opacity: 1, y: 0, transition: { duration: 0.6, ease, delay: d } } });

const GROUPS = [
  { Icon: FaStar,   bg: "#4a5e42", label: "Veterans",          accent: false, desc: "U.S. military veterans of all eras and branches." },
  { Icon: FaBolt,   bg: "#a86642", label: "First Responders",  accent: true,  desc: "Paramedics, EMTs, firefighters, and emergency personnel." },
  { Icon: FaShield, bg: "#384e56", label: "Law Enforcement",   accent: false, desc: "Active or retired law enforcement officers and deputies." },
  { Icon: FaAward,  bg: "#a86642", label: "Gold Star Families",accent: true,  desc: "Immediate family members of fallen service members." },
];

export default function ApplyWhoCanApply() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });

  return (
    <section className="awca" ref={ref}>
      <div className="container-fg container-2xxl">

        <motion.div className="awca__eyebrow-row" variants={fadeUp(0)} initial="hidden" animate={inView ? "show" : "hidden"}>
          <span className="awca__rule" aria-hidden="true" />
          <h2 className="awca__heading u-eyebrow">Who Can Apply</h2>
          <span className="awca__rule" aria-hidden="true" />
        </motion.div>

        <div className="awca__grid">
          {GROUPS.map((g, i) => (
            <motion.div key={g.label} className="awca__card"
              variants={fadeUp(0.07 + i * 0.08)} initial="hidden" animate={inView ? "show" : "hidden"}>
              <div className="awca__icon-wrap" style={{ background: g.bg }} aria-hidden="true">
                <g.Icon />
              </div>
              <h3 className={`awca__label ${g.accent ? "awca__label--rust" : ""}`}>{g.label.toUpperCase()}</h3>
              <p className="awca__desc">{g.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
